import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-eyecatch c-eyecatch--delete" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-eyecatch__img" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mypage__ttl c-ttl" }, "サービス連携解除", -1)
const _hoisted_3 = { class: "p-mypage__sec" }
const _hoisted_4 = { class: "p-mypage__field-container" }
const _hoisted_5 = {
  key: 0,
  class: "p-errors"
}
const _hoisted_6 = { class: "c-error" }
const _hoisted_7 = { class: "p-fields" }
const _hoisted_8 = { class: "c-field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "detail"
}, "ご利用サービス", -1)
const _hoisted_10 = { class: "c-field__body" }
const _hoisted_11 = { class: "c-field__textarea" }
const _hoisted_12 = { class: "c-field has-submit has-mt" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "サービス連携を解除する", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "戻る", -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.asyncDeterringWrap(_ctx.quitService, this)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.errorMsgRef)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.errorMsgRef), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("fieldset", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.serviceName), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(["c-btn is-submit", { 'is-disabled':_ctx.isDeterringRef }])
              }, _hoisted_14, 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["c-btn c-btn--outline", { 'is-disabled':_ctx.isDeterringRef }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push({ name: 'MypageTop' })))
              }, _hoisted_16, 2)
            ])
          ])
        ])
      ], 32)
    ])
  ], 64))
}